import _ from 'lodash'

export const areStringsEqual = (string?: string, stringToCompare?: string): boolean => {
  if (_.isNil(string) || _.isNil(stringToCompare)) return false
  return _.isEqual(_.toLower(string), _.toLower(stringToCompare))
}
